module.exports = __webpack_public_path__ + "img/JL_tip.a13cc361.png";